import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import router from './router'

// 屏蔽 Chrome 在拖拽窗口/DevTools 时的 ResizeObserver 噪声（含 overlay）
const muteResizeObserverError = (event) => {
  const msg = event?.message || event?.reason?.message || ''
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation?.()
    event.preventDefault?.()
    return true
  }
  return false
}
// 捕获阶段拦截，确保在 dev-server overlay 前阻止
window.addEventListener('error', muteResizeObserverError, true)
window.addEventListener('unhandledrejection', muteResizeObserverError, true)

// 开发环境额外屏蔽相关 console.error，防止 dev-server overlay 弹窗
if (process.env.NODE_ENV === 'development') {
  const rawError = console.error
  console.error = (...args) => {
    const hit = args?.some?.((a) => typeof a === 'string' && a.includes('ResizeObserver loop'))
    if (hit) return
    return rawError.apply(console, args)
  }
}

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})

app.mount('#app')

